exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".diabled-add{opacity:.8;pointer-events:none}.vs__deselect{align-items:center}#dealerships_select{border:1px solid #e2e5ed;box-shadow:inset 0 1px 2px 0 rgba(102,113,123,.21)}", ""]);

// exports
